import "./About.css";
import NavBar from "../NavBar";
import Footer from "../Footer";
import "bootstrap/dist/css/bootstrap.min.css";

function About() {
  return (
    <div className="About">
      <NavBar />
      <div className="content">
        <div className="main-container">
          <div className="profile">
            <div className="image"></div>
            <div className="cover"></div>
            <div className="intro">
              <h2 className="intro-name">Developer : Lakshan Rukantha</h2>
              <a
                title="Open Official Website"
                href="http://lakshanrukantha.github.io"
                target="blank"
              >
                <h2 className="intro-username">@lakshanrukantha</h2>
              </a>
            </div>
          </div>
          <div className="app-info">
            <div className="info-area">
            <h4 className="about-title">About</h4>
              <div className="description">
                <p className="para">
                  This web application has been created by entering the
                  birthdays of the software engineering students of NSBM
                  University. This is designed because it is difficult for many
                  people to remember their birthdays, so birthdays are
                  automatically displayed on those days. That has been the
                  primary objective here.
                </p>
                <div className="para">
                  <h4 className="version">Version : 0.1.1</h4>
                </div>
              </div>
            </div>
            <div className="bottom-svg">
              <svg
                width="100%"
                height="100%"
                id="svg"
                viewBox="0 0 1440 600"
                xmlns="http://www.w3.org/2000/svg"
                className="transition duration-300 ease-in-out delay-150"
              >
                <defs>
                  <linearGradient
                    id="gradient"
                    x1="0%"
                    y1="50%"
                    x2="100%"
                    y2="50%"
                  >
                    <stop offset="5%" stopColor="#002bdc88"></stop>
                    <stop offset="95%" stopColor="#32ded488"></stop>
                  </linearGradient>
                </defs>
                <path
                  d="M 0,600 C 0,600 0,200 0,200 C 90.82296650717703,214.05741626794259 181.64593301435406,228.11483253588517 266,233 C 350.35406698564594,237.88516746411483 428.2392344497607,233.5980861244019 537,231 C 645.7607655502393,228.4019138755981 785.3971291866029,227.4928229665072 891,211 C 996.6028708133971,194.5071770334928 1068.1722488038279,162.4306220095694 1154,158 C 1239.8277511961721,153.5693779904306 1339.9138755980862,176.7846889952153 1440,200 C 1440,200 1440,600 1440,600 Z"
                  stroke="none"
                  strokeWidth="0"
                  fill="url(#gradient)"
                  className="transition-all duration-300 ease-in-out delay-150 path-0"
                ></path>
                <defs>
                  <linearGradient
                    id="gradient"
                    x1="0%"
                    y1="50%"
                    x2="100%"
                    y2="50%"
                  >
                    <stop offset="5%" stopColor="#002bdcff"></stop>
                    <stop offset="95%" stopColor="#32ded4ff"></stop>
                  </linearGradient>
                </defs>
                <path
                  d="M 0,600 C 0,600 0,400 0,400 C 91.87559808612443,370.688995215311 183.75119617224885,341.377990430622 284,341 C 384.24880382775115,340.622009569378 492.87081339712915,369.177033492823 591,374 C 689.1291866028708,378.822966507177 776.7655502392346,359.9138755980861 880,377 C 983.2344497607654,394.0861244019139 1102.066985645933,447.1674641148325 1198,457 C 1293.933014354067,466.8325358851675 1366.9665071770335,433.4162679425838 1440,400 C 1440,400 1440,600 1440,600 Z"
                  stroke="none"
                  strokeWidth="0"
                  fill="url(#gradient)"
                  className="transition-all duration-300 ease-in-out delay-150 path-1"
                ></path>
              </svg>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default About;
